/*
	"2026-10-15" → "Mié 15 oct 2026". Se arma a mano (sin new Date(iso)) para no
	pasar por UTC, que en la noche corre la fecha un dia.
*/
const DIAS = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]

export const fechaBonita = (iso : string | null | undefined) : string =>
{
	if(!iso) return ""

	const partes = String(iso).substring(0, 10).split("-").map(Number)

	if(partes.length !== 3 || partes.some(isNaN)) return String(iso)

	const [y, m, d] = partes
	const fecha     = new Date(y, m - 1, d)

	return DIAS[fecha.getDay()] + " " + d + " " + MESES[m - 1] + " " + y
}
